<template>
  <page>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="newBlk">mdi-plus</v-icon>
        <v-icon v-else-if="queryBlk">mdi-magnify</v-icon>
        <v-icon v-else>mdi-pencil</v-icon>
        <v-toolbar-title v-if="newBlk">Create New Block</v-toolbar-title>
        <v-toolbar-title v-else-if="queryBlk">Query Block</v-toolbar-title>
        <v-toolbar-title v-else>Edit Block</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6 v-if="newBlk">
              <v-autocomplete
                :items="accmTypeList"
                v-model="blkForm.accmType"
                :label="labels.accmType"
                item-text="label"
                item-value="value"
                data-vv-name="accmType"
                :data-vv-as="labels.accmType"
                :error-messages="errors.collect('accmType')"
                @change="setValue()"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
              <div class="queryValue">{{ getDesc(blkForm.accmType) }}</div>
            </v-flex>
            <v-flex xs6 v-if="newBlk">
              <v-text-field
                v-model="blkForm.blkGrp"
                :label="labels.blkGrp"
                :error-messages="errors.collect('blkGrp')"
                data-vv-name="blkGrp"
                :data-vv-as="labels.blkGrp"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blkGrp')"
                v-validate="blkGrpValidate"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blkGrp }}</v-subheader>
              <div class="queryValue">{{ blkForm.blkGrp }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="newBlk">
              <v-text-field
                v-model="blkForm.blksGrp1"
                :label="labels.blksGrp1"
                :error-messages="errors.collect('blksGrp1')"
                data-vv-name="blksGrp1"
                :data-vv-as="labels.blksGrp1"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blksGrp1')"
                v-validate="blksGrp1Validate"
                :disabled="this.blkForm.blkGrp === '' || this.blkForm.blkGrp === undefined || this.blkForm.blkGrp === null"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blksGrp1 }}</v-subheader>
              <div class="queryValue">{{ blkForm.blksGrp1 }}</div>
            </v-flex>
            <v-flex xs6 v-if="newBlk">
              <v-text-field
                v-model="blkForm.blksGrp2"
                :label="labels.blksGrp2"
                :error-messages="errors.collect('blksGrp2')"
                data-vv-name="blksGrp2"
                :data-vv-as="labels.blksGrp2"
                append-icon="mdi-magnify"
                @click:append="getHelpList('blksGrp2')"
                v-validate="blksGrp2Validate"
                :disabled="this.blkForm.blksGrp1 === '' || this.blkForm.blksGrp1 === undefined || this.blkForm.blksGrp1 === null"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blksGrp2 }}</v-subheader>
              <div class="queryValue">{{ blkForm.blksGrp2 }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="newBlk">
              <v-text-field
                v-model="blkForm.blk"
                :label="labels.blk"
                :error-messages="errors.collect('blk')"
                data-vv-name="blk"
                :data-vv-as="labels.blk"
                :disabled="aeDisc"
                v-validate="'required|max:10'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.blk }}</v-subheader>
              <div class="queryValue">{{ blkForm.blk }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 v-if="!queryBlk">
              <v-text-field
                v-model="blkForm.blkDesc"
                :label="labels.blkDesc"
                :error-messages="errors.collect('blkDesc')"
                data-vv-name="blkDesc"
                :data-vv-as="labels.blkDesc"
                v-validate="'required|max:200'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-else>
              <v-subheader class="queryLabel">{{ labels.blkDesc }}</v-subheader>
              <div class="queryValue">{{ blkForm.blkDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="!queryBlk">
              <v-text-field
                v-model="blkForm.ownRtn"
                :label="labels.ownRtn"
                :error-messages="errors.collect('ownRtn')"
                data-vv-name="ownRtn"
                :data-vv-as="labels.blkDesc"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.ownRtn }}</v-subheader>
              <div class="queryValue">{{ blkForm.ownRtn }}</div>
            </v-flex>
            <v-flex xs6 v-if="newBlk">
              <cal-picker
                :label="labels.effDate"
                v-model="blkForm.effDate"
                :error-messages="errors.collect('effDate')"
                data-vv-name="effDate"
                :data-vv-as="labels.effDate"
                v-validate="'required'"
              ></cal-picker>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(blkForm.effDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="!queryBlk">
              <v-checkbox v-model="blkForm.inclNorm" :label="labels.inclNorm" data-vv-name="inclNorm" :data-vv-as="labels.inclNorm"></v-checkbox>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.inclNorm }}</v-subheader>
              <div class="queryValue">{{ blkForm.inclNorm }}</div>
            </v-flex>
            <v-flex xs12 v-if="!queryBlk">
              <v-text-field
                v-model="blkForm.remark"
                :label="labels.remark"
                :error-messages="errors.collect('remark')"
                data-vv-name="remark"
                :data-vv-as="labels.remark"
                v-validate="'max:1000'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-else>
              <v-subheader class="queryLabel">{{ labels.remark }}</v-subheader>
              <div class="queryValue">{{ blkForm.remark }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ blkForm.createdName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(blkForm.createdDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6 v-if="!newBlk">
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ blkForm.modifiedName }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newBlk">
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(blkForm.modifiedDate) }}</div>
            </v-flex>
            <v-flex xs6>
              <v-spacer class="mt-2"></v-spacer>
              <v-btn color="primary" dark class=" mr-2" v-if="!queryBlk" @click.native="doSave">
                {{ newBlk ? 'Save Block' : 'Save Block' }}
                <v-icon right>{{ newBlk ? 'mdi-content-save' : 'mdi-content-save' }}</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-dialog v-model="helplist" width="800px" persistent>
        <blk-grp-helplist
          v-if="blkGrpHelplist"
          :accmType="blkForm.accmType"
          @close="doCloseHelplist"
          @doAssign="doAssign1($event)"
        ></blk-grp-helplist>
        <blks-grp1-helplist v-if="blksGrp1Helplist" :blkGrpId="blkGrpId" @close="doCloseHelplist" @doAssign="doAssign2($event)"></blks-grp1-helplist>
        <blks-grp2-helplist
          v-if="blksGrp2Helplist"
          :blksGrpId="blksGrpId"
          @close="doCloseHelplist"
          @doAssign="doAssign3($event)"
        ></blks-grp2-helplist>
      </v-dialog>
    </v-card>
    <v-divider></v-divider>
    <blk-addl-desc v-if="!newBlk" :id="id"></blk-addl-desc>
  </page>
</template>

<script>
import { formatDisplayDate, removeTime } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import BlkGrpHelplist from '../BlockGroupHelplist'
import BlksGrp1Helplist from '../BlockSubGroup1Helplist'
import BlksGrp2Helplist from '../BlockSubGroup2Helplist'
import BlkAddlDesc from './blockAddlDesc/BlkAddlDesc'
import { removeFormatNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'

export default {
  props: ['mode', 'id'],
  data() {
    return {
      breadcrumb: [],
      title: '',
      labels: {
        accmType: 'Accumulation Type',
        blkGrp: 'Block Group',
        blksGrp1: 'Block Sub Group 1',
        blksGrp2: 'Block Sub Group 2',
        blk: 'Block',
        blkAe: 'Block AE',
        blkDesc: 'Description',
        ownRtn: 'Own Retention',
        effDate: 'Effective Date',
        inclNorm: 'Include Normalisation',
        remark: 'Remark',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      blkForm: {
        accmType: null,
        blkGrp: null,
        blksGrp1: null,
        blksGrp2: null,
        blk: null,
        blkAe: false,
        blkDesc: null,
        ownRtn: 0,
        effDate: new Date(),
        inclNorm: true,
        remark: null,
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedName: '',
        modifiedDate: null
      },
      seqNo: 0,
      blkGrpId: {},
      blksGrpId: {},
      helplist: false,
      blkGrpHelplist: false,
      blksGrp1Helplist: false,
      blksGrp2Helplist: false,
      newBlk: false,
      queryBlk: false,
      accmTypeList: [],
      submitting: false,
      aeDisc: false
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    },
    blkGrpValidate() {
      if (this.blkForm.blkGrp === undefined || this.blkForm.blkGrp === '' || this.blkForm.blkGrp === null || (this.labels.blkGrp === 'Block Group' && this.blkForm.accmType !== null)) {
        return 'required'
      } else {
        return ''
      }
    },
    blksGrp1Validate() {
      if (this.labels.blksGrp1 !== '' && this.labels.blksGrp1 !== undefined) {
        return 'required'
      } else {
        return ''
      }
    },
    blksGrp2Validate() {
      if (this.labels.blksGrp2 !== '' && this.labels.blksGrp2 !== undefined) {
        return 'required'
      } else {
        return ''
      }
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
    },
    blksGrp1Validate: {
      handler: function (isMandatory) {
        // if (isMandatory) {
        // } else {
        // }
      }
    }
  },
  methods: {
    async doInit() {
      // console.log(this.accmTypeList)
      if (this.mode === 'new') {
        this.newBlk = true
        this.queryBlk = false
        this.title = 'New Block'
      } else {
        const apiURI = this.menu.getBlk
        if (apiURI) {
          try {
            const result = await this.$http.put(apiURI, this.id)
            const { data } = result.data
            if (data) {
              this.blkForm.accmType = data.blk.accmType
              this.blkForm.blkGrp = data.blk.blkGrp
              this.blkForm.blksGrp1 = data.blk.blksGrp1
              this.blkForm.blksGrp2 = data.blk.blksGrp2
              this.blkForm.blk = data.blk.blk
              this.blkForm.blkAe = data.blk.blkAe
              this.blkForm.blkDesc = data.blk.blkDesc
              this.blkForm.effDate = data.blk.effDate
              this.blkForm.inclNorm = data.blk.inclNorm
              this.blkForm.remark = data.blk.remark
              this.blkForm.ownRtn = formatPrice(data.blk.ownRtn)
              this.blkForm.createdName = data.blk.createdName
              this.blkForm.createdDate = data.blk.createdDate
              this.blkForm.modifiedName = data.blk.modifiedName
              this.blkForm.modifiedDate = data.blk.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
        this.setValue()
        if (this.mode === 'edit') {
          this.newBlk = false
          this.queryBlk = false
          this.title = 'Review Block'
        } else {
          this.newBlk = false
          this.queryBlk = true
          this.title = 'Query Block'
        }
      }
    },
    getDesc(id) {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === id) {
          return this.accmTypeList[i].label
        }
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    ae() {
      if (this.blkForm.blkAe) {
        this.setBlksGrp2()
        this.aeDisc = true
      } else {
        this.aeDisc = false
      }
    },
    checkBlank(lb) {
      if (lb) {
        return lb
      } else {
        return '-'
      }
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType,
              blkGrpLblS: accmType.blkGrpLblS,
              blksGrp1LblS: accmType.blkSgrp1LblS,
              blksGrp2LblS: accmType.blkSgrp2LblS,
              blkLblS: accmType.blkLblS,
              defBlkAE: accmType.defBlkAE,
              nxtBlkSeq: accmType.nxtBlkSeq
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    setValue() {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === this.blkForm.accmType) {
          this.labels.blkGrp = this.accmTypeList[i].blkGrpLblS
          this.labels.blksGrp1 = this.accmTypeList[i].blksGrp1LblS
          this.labels.blksGrp2 = this.accmTypeList[i].blksGrp2LblS
          this.labels.blk = this.accmTypeList[i].blkLblS
          if (this.newBlk) {
            this.blkForm.blkAe = this.accmTypeList[i].defBlkAE
            if (this.blkForm.blkAe) {
              this.aeDisc = true
              this.blkForm.blk = this.accmTypeList[i].nxtBlkSeq.toString().padStart(8, '0')
            } else {
              this.aeDisc = false
              this.blkForm.blk = null
            }
            this.blkForm.blkGrp = null
            this.blkForm.blksGrp1 = null
            this.blkForm.blksGrp2 = null
          }
        }
      }
    },
    setBlksGrp2() {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === this.blkForm.accmType) {
          if (this.blkForm.blkAe) {
            this.blkForm.blk = this.accmTypeList[i].nxtBlkSeq.toString().padStart(8, '0')
          } else {
            this.blkForm.blk = null
          }
        }
      }
    },
    getHelpList(field) {
      if (field === 'blkGrp') {
        this.blkGrpHelplist = true
      } else if (field === 'blksGrp1') {
        this.blkGrpId.accmType = this.blkForm.accmType
        this.blkGrpId.blkGrp = this.blkForm.blkGrp
        this.blksGrp1Helplist = true
      } else if (field === 'blksGrp2') {
        this.blksGrpId.accmType = this.blkForm.accmType
        this.blksGrpId.blkGrp = this.blkForm.blkGrp
        this.blksGrpId.blksGrp1 = this.blkForm.blksGrp1
        this.blksGrp2Helplist = true
      }
      this.helplist = true
    },
    doCloseHelplist() {
      this.blkGrpHelplist = false
      this.blksGrp1Helplist = false
      this.blksGrp2Helplist = false
      this.helplist = false
    },
    doAssign1(blkGrp) {
      this.blkForm.blkGrp = blkGrp
      this.blkGrpValidate()
      // this.$validator.validateAll('blkGrp')
    },
    doAssign2(blksGrp1) {
      this.blkForm.blksGrp1 = blksGrp1
      this.blksGrp1Validate()
      // this.$validator.validateAll('blksGrp1')
    },
    doAssign3(blksGrp2) {
      this.blkForm.blksGrp2 = blksGrp2
      this.blksGrp2Validate()
      // this.$validator.validateAll('blksGrp2')
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newBlk) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createBlk
      if (apiURI) {
        this.submitting = true
        try {
          this.blkForm.effDate = removeTime(this.blkForm.effDate)
          this.blkForm.ownRtn = removeFormatNumber(this.blkForm.ownRtn)
          const result = await this.$http.post(apiURI, this.blkForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'blk' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateBlk
      if (apiURI) {
        this.submitting = true
        try {
          this.blkForm.ownRtn = removeFormatNumber(this.blkForm.ownRtn)
          const result = await this.$http.put(apiURI, this.blkForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'blk' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  async created() {
    await this.getAccmTypeList()
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    BlkGrpHelplist,
    BlksGrp1Helplist,
    BlksGrp2Helplist,
    BlkAddlDesc
  }
}
</script>
